import type { ComponentType, SVGProps } from 'react';
import { IconCalendar } from '@/components/icons/IconCalendar';
import { IconGauge } from '@/components/icons/IconGauge';
import { IconGearSix } from '@/components/icons/IconGearSix';
import { IconLightning } from '@/components/icons/IconLightning';
import { cn } from '@/lib/utils/tw-merge';
import type { VehicleSpec, VehicleSpecIcon } from './vehicle.types';

// Direct imports: the listing renders this in the browser, the UiIcon registry
// would ship every icon of the site with it.
const SPEC_ICONS: Record<VehicleSpecIcon, ComponentType<SVGProps<SVGSVGElement>>> = {
    registration: IconCalendar,
    mileage: IconGauge,
    power: IconLightning,
    transmission: IconGearSix,
};

/** The icons carry the meaning visually; screen readers get it as text. */
const SPEC_LABELS: Record<VehicleSpecIcon, string> = {
    registration: 'Erstzulassung',
    mileage: 'Kilometerstand',
    power: 'Leistung',
    transmission: 'Getriebe',
};

export function VehicleSpecs({ specs, className }: { specs: VehicleSpec[]; className?: string }) {
    if (!specs.length) return null;

    return (
        <ul className={cn('vehicle-specs', className)}>
            {specs.map(({ icon, value }) => {
                const Icon = SPEC_ICONS[icon];

                return (
                    <li key={icon} className="vehicle-specs__item label-sm">
                        <Icon className="vehicle-specs__icon" aria-hidden="true" />
                        <span className="sr-only">{SPEC_LABELS[icon]}: </span>
                        {value}
                    </li>
                );
            })}
        </ul>
    );
}
